import api from './index';

interface PostPlacementTestResultProps {
  token: string;
}

const postSkipTest = (props?: PostPlacementTestResultProps) => {
  return api.post(`/v4/placement-test/skip`, props);
};

interface GetPlacementTestResult {
  result: string;
  levelPosition: number;
  unitPosition: number;
  skippedPlacement: boolean;
}

const getPlacementTestResult = async () => {
  const { data } = await api.get<GetPlacementTestResult>(`/v4/placement-test-result`);
  return data;
};

export const PlacementTestService = {
  postSkipTest,
  getPlacementTestResult,
};
